import script from "./banner.vue?vue&type=script&setup=true&lang=js"
export * from "./banner.vue?vue&type=script&setup=true&lang=js"

import "./banner.vue?vue&type=style&index=0&id=1819953b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1819953b"]])

export default __exports__